import { EntityType } from './types';

export function getEntityStorePath(entityType: EntityType): string {
  switch (entityType) {
    case EntityType.PRODUCT:
      return 'productsModule';
    case EntityType.SHOPIFY_PRODUCT:
      return 'shopifyProductsModule';
    case EntityType.COLOR:
      return 'colorsModule';
    case EntityType.CATEGORY:
      return 'categoriesModule';
    case EntityType.QUANTITY_BREAK:
      return 'quantityBreaksModule';
    case EntityType.COLOR_GROUP:
      return 'colorGroupsModule';
    case EntityType.PRODUCT_CATEGORY_OPTION:
      return 'productCategoryOptionsModule';
    case EntityType.PRODUCT_CATEGORY_ATTRIBUTE:
      return 'productCategoryAttributesModule';
    case EntityType.PRODUCTION_TIME:
      return 'productionTimesModule';
    case EntityType.PREORDER_PRODUCT:
      return 'preorderProductsModule';
    case EntityType.FONT:
      return 'fontsModule';
    case EntityType.FONT_GROUP:
      return 'fontGroupsModule';
    default:
      console.error('No entity module matches provided entity type');
      return '';
  }
}
